import { render, staticRenderFns } from "./MiddlewareTransactionListComponent.vue?vue&type=template&id=4e610ae0&"
import script from "./MiddlewareTransactionListComponent.vue?vue&type=script&lang=js&"
export * from "./MiddlewareTransactionListComponent.vue?vue&type=script&lang=js&"
import style0 from "./MiddlewareTransactionListComponent.vue?vue&type=style&index=0&id=4e610ae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports